const depthColors = [
    {
        minLimit: null,
        maxLimit: 30,
        color: "#FF0000"
    },
    {
        minLimit: 30,
        maxLimit: 70,
        color: "#EBEB00"
    },
    {
        minLimit: 70,
        maxLimit: 120,
        color: "#00FF00"
    },
    {
        minLimit: 120,
        maxLimit: 180,
        color: "#0000FF"
    },
    {
        minLimit: 180,
        maxLimit: null,
        color: "#C800F6"
    },
];

export const colorsToClassName = {
   "#FF0000": "red",
   "#EBEB00": "yellow",
   "#00FF00": "green",
   "#0000FF": "blue",
   "#C800F6": "purple",
}

const calculateColor = (depth) => {
    let color = null;
    for (let index = 0; index < depthColors.length; index++) {
        const depthItem = depthColors[index];
        const maxLimit = depthItem.maxLimit
        if (maxLimit) {
            if (depth < maxLimit) {
                color = depthItem.color;
                break;
            }
        } else {
            color = depthItem.color;
            break;
        }
    };
    return color;
};


export { depthColors, calculateColor };
